<template>
  <div id="app" :class="{'--no-event': isLandscape}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      isLandscape: false
    }
  },
  created () {
    const that = this
    that.checkLandScape()
    window.addEventListener('resize', function () {
      that.checkLandScape()
    })
  },
  methods: {
    checkLandScape () {
      switch (window.orientation) {
        case 90:
        case -90:
          this.isLandscape = true
          break
        default:
          this.isLandscape = false
          break
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/style/common.scss";
  .warn-text {
    color: #ff8f00!important;
  }
  #app.--no-event {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue